import { Component } from '@angular/core';

@Component({
    selector: 'contact-sales',
    templateUrl: './contact-sales.component.html',
    standalone: false
})
export class ContactSalesComponent {
}
